import React from 'react';
import type { DashboardProps } from './dashboard/types';
import DashboardContent from './dashboard/DashboardContent';
import { useDashboard } from '../hooks/useDashboard';

const Dashboard: React.FC<DashboardProps> = (props) => {
  const model = useDashboard(props);
  return <DashboardContent {...model} />;
};

export default Dashboard;
